export const blockIconsActivitiesPersonalInjuryNew = (
	<span className='material-symbols-outlined'>personal_injury</span>
);
